// Utilities for the Coach video upload component.
// This file serves as a container for any DOM/event initialization needed by RSVideoUpload.
// Note: Actual recording/upload logic is implemented elsewhere.

import { onLink, onSubmit } from '../../../handlers';
import RSVideoUpload from './RSVideoUpload';
import { getUsefulVars } from '../../../handlers/helpers';

/**
 * Initialize basic UI behaviors for the video recorder container.
 * This safely checks for required elements and leaves the heavy lifting
 * (recording, uploading) to existing scripts.
 */
export const initCoachVideoRecorder = () => {
  const openNavBtn = typeof document !== 'undefined' ? document.getElementById('openNav') : null;
  const uploadSection = typeof document !== 'undefined' ? document.getElementById('uploadSection') : null;

  if (openNavBtn && uploadSection) {
    // Example: toggle the upload section panel visibility via the nav button.
    openNavBtn.addEventListener('click', () => {
      const isHidden = uploadSection.style.display === 'none' || uploadSection.style.display === '';
      uploadSection.style.display = isHidden ? 'block' : 'none';
    });
  }
};

/**
 * Simple helper for updating a status area if present.
 */
export const setCoachVideoStatus = (msg) => {
  const status = typeof document !== 'undefined' ? document.getElementById('statusMessage') : null;
  if (status) {
    status.textContent = msg ?? '';
  }
};
export  const handleQuestionSelect = (event, props) => {
  const selectedQuestion = event.target.value;
  props.stateProps.setInterviewQuestion(selectedQuestion);
  if (selectedQuestion) {
    interviewCoachLink(props, selectedQuestion);
  }
};
export const interviewCoachLink = (props) => {
onLink(false, props.formikProps, props.stateProps, 'interview-coacher', 0, 'section', props.stateProps.sectionData.resumeIndex, props);

}
export const editMIResults = (props) => {
  const uv = getUsefulVars(props);
  if(window.confirm('Are you sure you want to delete your existing results?')) {
    const uv = getUsefulVars(props);
    interviewCoachLink(props);
  }
}